import { render, staticRenderFns } from "./svg-dev.vue?vue&type=template&id=2323b49d&"
import script from "./svg-dev.vue?vue&type=script&lang=js&"
export * from "./svg-dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports